import { render, staticRenderFns } from "./couponsConfig.vue?vue&type=template&id=49ac4886&scoped=true"
import script from "./couponsConfig.vue?vue&type=script&lang=js"
export * from "./couponsConfig.vue?vue&type=script&lang=js"
import style0 from "./couponsConfig.vue?vue&type=style&index=0&id=49ac4886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac4886",
  null
  
)

export default component.exports